import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, debounceTime, Subscription } from 'rxjs';
import { WholesalerPharmacyService } from '../../services';
import { ICON_TYPE } from '@spartacus/storefront';

@Component({
  selector: 'app-wholesaler-search',
  templateUrl: './wholesaler-search.component.html',
})
export class WholesalerSearchComponent implements OnInit {
  constructor(protected wholesalerPharmacyService: WholesalerPharmacyService) {}

  minLength = 3;
  iconTypes = ICON_TYPE;

  searchText$ = new BehaviorSubject<string>('');
  subscriptions = new Subscription();

  ngOnInit(): void {
    this.subscriptions.add(
      this.searchText$.pipe(debounceTime(500)).subscribe((searchValue) => {
        if (searchValue.length >= this.minLength) {
          this.wholesalerPharmacyService.searchWholesalers({
            value: searchValue,
          });
        }
      })
    );
  }

  search(searchValue: string) {
    this.searchText$.next(searchValue);
  }
}
